import React, { Component } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import './index.less';

const areaSource = {
    beginDrag(props, monitor, component) {
        return {
            index: props.index,
            laneIndex: props.laneIndex,
            canDrop: props.areaItem.areatype == '2',
            areaItem: props.areaItem,
            areaComp: component,
        };
    },
    canDrag(props) {
        return props.areaItem.areatype === '2' || props.areaItem.headcode !== props.areaItem.code; //表头区域不能拖拽
    },
};

const areaTarget = {
    drop(props, monitor) {
        const dragItem = monitor.getItem();

        if (!monitor.isOver({ shallow: true })) {return;}
        //区域类型不同不能拖拽
        if (props.areaItem && props.areaItem.areatype !== dragItem.areaItem.areatype) {return;}

        props.dropLogic('tag', {
            dragIndex: dragItem.index,
            targetIndex: props.index,
            laneIndex: dragItem.laneIndex,
            targetLaneIndex: props.laneIndex,
        });
    },
    canDrop(props, monitor) {
        let dragItem = monitor.getItem();
        let dropItem = props.areaItem;
        if (dragItem) {
            let ret = dragItem.areaItem.areatype === dropItem.areatype;
            if (!ret) {
                dragItem.areaComp && dragItem.areaComp.setState({ canShowDragHover: true });
            }
            return ret;
        }
        return dropItem.areatype === '2' || dropItem.headcode !== dropItem.code; //表头区域不能拖拽
    },
};

@DragSource('tag', areaSource, (connect, monitor) => {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
        canDrag: monitor.canDrag(),
        dragItem: monitor.getItem(),
    };
})
@DropTarget('tag', areaTarget, (connect, monitor) => {
    let item = monitor.getItem();
    let canDrop = item && item.canDrop;
    let areaItem = item && areaItem;
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        canShowDragHover: monitor.canDrop() && monitor.isOver(),
    };
})
class AreaTag extends Component {

    render() {
        const { connectDragSource, connectDropTarget, name, areaItem, canShowDragHover, isOver } = this.props;
        const iconCls = areaItem.areatype === '1' ? 'icon-kapian' : areaItem.areatype === '2' ? 'icon-liebiao1' : '';
        return connectDragSource(
            connectDropTarget(
                <div className={`tag${this.props.nodrop ? ' nodrop' : ''} `} style={
                    !this.props.nodrop && canShowDragHover ? { cursor: 'no-drop' } : {}
                }>
                    {isOver && <div className="drag-hover"></div>}
                    <span>{name}<i className={`iconfont ${iconCls}`}></i></span>
                </div>,
            ),
        );
    }
}

export default AreaTag;
